export { anchorOriginVars, surfaceAnimation } from './overlay.animations'
export * from './overlay.component'
export * from './overlay.confirm-body'
// The law a surface obeys while the finger drags it away, as numbers. The
// answer to "make this modular": what is shared is the law, not a recognizer —
// a recognizer on the surface would be usable only by content that owns no
// gesture of its own, which is exactly the content that does not need this.
export * from './overlay.dismiss-law'
export * from './overlay.service'
export type {
	Anchor,
	CloseReason,
	Content,
	OverlayBeforeCloseDetail,
	OverlayConfirmOptions,
	OverlayEntry,
	OverlayLayout,
	OverlayPromptOptions,
	ShowFn,
	ShowOptions,
	TemplateFactory,
} from './overlay.types'
export { lazy } from '@schmancy/router/lazy'
